import { useMutation } from '@tanstack/react-query';
import { AttachmentReportService } from '@/infra/services/attachment';

interface CreateAttachmentParams {
	organization_id: string;
	company_id: string;
	origin_table: string;
	table_origin_id: string;
	file: {
		generated_name: string;
		original_name: string;
		size: number;
	};
}

const Service = AttachmentReportService.getInstance();

export function useCreateAttachment() {
	return useMutation({
		mutationFn: (params: CreateAttachmentParams) => Service.create(params)
	});
}
